import { useQuery } from '@tanstack/react-query';
import { getPreRegisteredUserForTeacher } from '../api/teachers';

const useFetchPreRegisteredUserForTeacher = (userId) => {
  return useQuery({
    queryKey: ['getPreRegisteredUserForTeacher', userId],
    queryFn: async () => {
      // Fetching data using the API function
      const fetchedData = await getPreRegisteredUserForTeacher(userId);

      return (
        fetchedData?.map((student) => ({
          id: student.id,
          teacherId: student.teacherId || student.teacherID || '',
          teacherName: student.teacherName || student.info.teacherName || '',
          name: student.info.name || student.info.fullname || '',
          email: student.info.email,
          parentName: student.info.parentName,
          dob: student.info.dob || '',
          gender: student.info.gender || '',
          selfDescribeGender: student.info.selfDescribeGender || '',
          grade: student.info.grade || '',
          contactNo: student.info.contactNo || '',
          photoURL: student.info?.photoURL || null,
          admissionNumber: student.info.admissionNumber || student.info.studentId || '',
          studentId: student.info.studentId || student.info.admissionNumber || '',
        })) || []
      );
    },
    enabled: !!userId, // Only run query if userId exists
    staleTime: 10 * 60 * 1000, // 10 minutes - data is considered fresh for 10 min
    gcTime: 30 * 60 * 1000, // 30 minutes cache (formerly cacheTime)
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
    refetchOnMount: false, // Don't refetch when component mounts if data is fresh
    refetchOnReconnect: true, // Refetch when reconnecting to network
    onError: (error) => {
      console.error('Error fetching pre-registered users:', error);
    },
  });
};

export default useFetchPreRegisteredUserForTeacher;
